import React from 'react';
import { Shield, Brain, TrendingUp } from 'lucide-react';

const Solucion = () => {
  const capas = [
    {
      number: "01",
      icon: <Shield size={40} />,
      title: "Capa de seguridad y anonimización",
      description: "Configuramos un entorno estanco. Tus datos y los de tus clientes nunca entrenarán a modelos externos. Usamos herramientas de grado bancario para garantizar el secreto profesional.",
      image: "https://images.unsplash.com/photo-1768839721176-2fa91fdce725?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwzfHxjeWJlcnNlY3VyaXR5JTIwZGF0YSUyMHByb3RlY3Rpb258ZW58MHx8fHwxNzc1MTUxNzE1fDA&ixlib=rb-4.1.0&q=85"
    },
    {
      number: "02",
      icon: <Brain size={40} />,
      title: "Capa de ingeniería de instrucciones",
      description: "No usamos comandos genéricos. Desarrollamos una biblioteca de activos jurídicos propia para tu despacho: desde el análisis de demandas complejas hasta la síntesis de pruebas testificales.",
      image: "https://images.unsplash.com/photo-1674027444485-cec3da58eef4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwzfHxhcnRpZmljaWFsJTIwaW50ZWxsaWdlbmNlfGVufDB8fHx8MTc3NTE1MTcyMHww&ixlib=rb-4.1.0&q=85"
    },
    {
      number: "03",
      icon: <TrendingUp size={40} />,
      title: "Capa de estrategia de negocio",
      description: "Revisamos tu estructura de costes. Si la IA hace el 80% del trabajo mecánico, redefinimos cómo aportas valor para que tu ticket no baje, sino que tu margen suba.",
      image: "https://images.unsplash.com/photo-1523875194681-bedd468c58bf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwzfHxidXNpbmVzcyUyMHN0cmF0ZWd5fGVufDB8fHx8MTc3NTE1MTcyNXww&ixlib=rb-4.1.0&q=85"
    }
  ];

  return (
    <section id="solucion" className="bg-reset-black py-24">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-light text-white mb-6">
            El método de las <span className="italic text-reset-gold">tres capas</span>
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto leading-relaxed">
            Un sistema completo que transforma tu despacho en un ecosistema tecnológico avanzado sin comprometer tu ética profesional.
          </p>
        </div>

        <div className="space-y-12">
          {capas.map((capa, index) => (
            <div 
              key={index}
              className={`flex flex-col ${index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'} gap-8 items-center`}
            >
              {/* Image */}
              <div className="w-full md:w-1/2">
                <div className="relative overflow-hidden aspect-video">
                  <img 
                    src={capa.image}
                    alt={capa.title}
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-reset-black/60 to-transparent"></div>
                </div>
              </div>

              {/* Content */}
              <div className="w-full md:w-1/2 space-y-4">
                <div className="flex items-center gap-4">
                  <span className="text-6xl font-bold text-reset-gold/20">{capa.number}</span>
                  <div className="text-reset-gold">{capa.icon}</div>
                </div>
                <h3 className="text-2xl font-semibold text-white">
                  {capa.title}
                </h3>
                <p className="text-gray-400 leading-relaxed text-lg">
                  {capa.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Solucion;